import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_r52w2qo7l3: FaireBrandEntity = {
  token: "b_r52w2qo7l3",
  type: "brand",
  name: "USA Toyz",
  avatarUrl:
    "https://cdn.faire.com/fastly/d3fa1a68f156fa130d6913c1fdf211df6897c130db3288fa755d0d62e35ee7e5.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/e3bac58b0510037148dfddc20428eb57c779bbed3316b06e8327d76dfa0c2070.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/d3fa1a68f156fa130d6913c1fdf211df6897c130db3288fa755d0d62e35ee7e5.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e3bac58b0510037148dfddc20428eb57c779bbed3316b06e8327d76dfa0c2070.jpeg",
  location: "Hillside, NJ, USA",
  minimumOrderDollars: 150,
  rating: 4.6,
  reviewCount: 40,
  isInsider: true,
  description:
    "USA Toyz is your one-stop toy shop for Award-winning drones, RC boats, tents, STEM toys, & more!",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:55.357Z",
    importedBy: "entity-db-cli",
  },
};
